module.exports = __webpack_public_path__ + "static/media/Tick-Positive.bd2473de.svg";